import {createSelector} from 'reselect';

const selectFwu = (state) => state.fwu;

const selectFwuAvailableInfo = createSelector(selectFwu, (fwu) => fwu?.fwuAvailableInfo);
const selectHolderFwuAvailableInfo = createSelector(selectFwu, (fwu) => fwu?.holderFwuAvailableInfo);
const selectNextChargerVersion = createSelector(selectFwuAvailableInfo, (fwuAvailableInfo) => {
    return {
        firmwareVersion: fwuAvailableInfo?.availableFirmwares?.[0]?.version,
        engineFirmwareVersion: fwuAvailableInfo?.availableAssociatedFirmwares?.engine?.[0]?.version,
        bleFirmwareVersion: fwuAvailableInfo?.availableAssociatedFirmwares?.BLE?.[0]?.version,
    };
});
const selectNextHolderVersion = createSelector(selectHolderFwuAvailableInfo, (fwuAvailableInfo) => {
    return {
        firmwareVersion: fwuAvailableInfo?.availableFirmwares?.[0]?.version,
        engineFirmwareVersion: fwuAvailableInfo?.availableAssociatedFirmwares?.engine?.[0]?.version,
        bleFirmwareVersion: fwuAvailableInfo?.availableAssociatedFirmwares?.BLE?.[0]?.version,
    };
});
const selectIsFwuAvailable = createSelector(
    selectNextChargerVersion,
    selectNextHolderVersion,
    (nextChargerVersion, nextHolderVersion) =>
        nextChargerVersion.firmwareVersion ||
        nextChargerVersion.engineFirmwareVersion ||
        nextChargerVersion.bleFirmwareVersion ||
        nextHolderVersion.firmwareVersion ||
        nextHolderVersion.engineFirmwareVersion ||
        nextHolderVersion.bleFirmwareVersion
);

export {selectIsFwuAvailable, selectNextChargerVersion, selectNextHolderVersion};
